import React from 'react';
import type { FC } from 'react';

import { ConfluenceSmartCardProvider } from '@confluence/smart-card-provider/entry-points/ConfluenceSmartCardProvider.tsx';

import { MeetingsPanel } from './MeetingsPanel.tsx';

/**
 * Production wrapper for the Meetings pill content.
 *
 * `MeetingsPanel` opens a recording in an embedded smart-link Card
 * (`<Card appearance="embed">`) inside a modal. That Card resolves the Loom URL
 * via a `SmartCardProvider` ancestor. On the For You feed the ambient Confluence
 * smart-card provider is NOT in scope, so we mount one here.
 *
 * `doNotUsePreviewPanels` keeps this to the lightweight smart-card path and
 * avoids pulling in the side preview-panel + Relay environment machinery, which
 * the feed does not need.
 *
 * Tests and Storybook render `MeetingsPanel` directly (mocking the embed modal),
 * so this wrapper is only used in the real app.
 */
export const MeetingsPanelWithProvider: FC = () => (
	<ConfluenceSmartCardProvider doNotUsePreviewPanels>
		<MeetingsPanel />
	</ConfluenceSmartCardProvider>
);
